/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import Navbar from "../../components/Navigation/Navbar/Navbarnou";
import "./vaults.css";
import Card from "./Card";
import farms from "../../jsons/farms.json";

const Vaults = () => {
  return (
    <>
      <Navbar />
      <div className="main_offer">
        <div className="container-fluid">
          <div className="header_img">
            <h1>Singh Coin Reward Pools</h1>
            <p>Stake Pancake LPs to earn SINGH.</p>
            {/* <h2 class="text-light bg-dark">
              Alert: Unstake and Claim your funds from the all pool except
              SINGH/BNB. Other pools are no longer available, invest in
              SINGH/BNB pool and earn SINGH Token. Last date for unstake and
              claim reward is 15th April 2023. For any support contact on
              Telegram
              <a
                href="https://t.me/SinghApp_support"
                rel="noreferrer"
                target="_blank"
              >
                {" "}
                @SinghApp_support
              </a>
            </h2> */}
          </div>
          <div className="row">
            {farms.map((i, index) => {
              return (
                <Card
                  index={i.index}
                  name={i.pair}
                  farm={true}
                  taddress={i.address}
                  pair={i.pair}
                  image={i.imageURI}
                  priceTag={i.priceTag}
                  quoteTokenAddress={i.quoteTokenAddress}
                />
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default Vaults;
